import React, { useState, useEffect } from 'react';
import SectionHead from '../components/SectionHead';

const galleryImages = [
  { id: 1, src: '/assets/Residential-1.jpg', title: 'Residential Lift', category: 'Residential' },
  { id: 2, src: '/assets/Residential-2.jpg', title: 'Residential Installation', category: 'Residential' },
  { id: 3, src: '/assets/Commerical-1.jpg', title: 'Commercial Elevator', category: 'Commercial' },
  { id: 4, src: '/assets/Commercial-2.jpg', title: 'Commercial Installation', category: 'Commercial' },
  { id: 5, src: '/assets/Commerical-3.jpg', title: 'Commercial Lift', category: 'Commercial' },
  { id: 6, src: '/assets/Commerical-4.jpg', title: 'Office Building Elevator', category: 'Commercial' },
  { id: 7, src: '/assets/panormic-galss-1.jpg', title: 'Panoramic Glass Lift', category: 'Residential' },
  { id: 8, src: '/assets/panormic-glass-2.jpg', title: 'Glass Elevator', category: 'Residential' },
  { id: 9, src: '/assets/panormic-glass-3.jpg', title: 'Panoramic View Lift', category: 'Residential' },
];

const CAROUSEL_INTERVAL_MS = 5000;

function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    }, CAROUSEL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  const goTo = (index) => setCurrentIndex(index);
  const prev = () => setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  const next = () => setCurrentIndex((prev) => (prev + 1) % galleryImages.length);

  return (
    <section className="section" id="gallery">
      <SectionHead
        title="Our Gallery"
        copy="Explore our portfolio of premium elevator installations across residential and commercial projects. Each installation showcases our commitment to quality, design, and innovation."
      />

      <div className="gallery-carousel">
        <div className="gallery-carousel-track">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className={`gallery-carousel-slide ${index === currentIndex ? 'active' : ''}`}
              aria-hidden={index !== currentIndex}
            >
              <img src={image.src} alt={image.title} />
              <div className="gallery-carousel-caption">
                <h3>{image.title}</h3>
                <p>{image.category}</p>
              </div>
            </div>
          ))}
        </div>
        <button
          type="button"
          className="gallery-carousel-btn gallery-carousel-prev"
          onClick={prev}
          aria-label="Previous image"
        >
          <span aria-hidden>‹</span>
        </button>
        <button
          type="button"
          className="gallery-carousel-btn gallery-carousel-next"
          onClick={next}
          aria-label="Next image"
        >
          <span aria-hidden>›</span>
        </button>
        <div className="gallery-carousel-dots">
          {galleryImages.map((image, index) => (
            <button
              key={image.id}
              type="button"
              className={`gallery-carousel-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goTo(index)}
              aria-label={`Go to image ${index + 1}`}
              aria-current={index === currentIndex}
            />
          ))}
        </div>
      </div>

      <div className="gallery-grid">
        {galleryImages.map((image) => (
          <div key={image.id} className="gallery-item">
            <div className="gallery-image">
              <img src={image.src} alt={image.title} />
            </div>
            <div className="gallery-overlay">
              <h3>{image.title}</h3>
              <p>{image.category}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;
